// 身份驗證
export const requiredRules = (name, trigger = 'blur') => {
  if (trigger == 'change') {
    return { required: true, message: `請選擇${name}`, trigger }
  } else {
    return { required: true, message: `請輸入${name}`, trigger }
  }
}
export const MaxRules = (size) => {
  return { max: size, message: `長度最多在${size}個字符`, trigger: 'blur' }
}

export const identityCardRules = () => {}
